export enum StudentTypes {
  EDIT_STUDENT = '@student/EDIT_STUDENT',
  EDIT_STUDENT_REQUEST = '@student/EDIT_STUDENT_REQUEST',
  EDIT_STUDENT_PREFERENCE = '@student/EDIT_STUDENT_PREFERENCE',
  EDIT_SHOW_HOW_KNOW = '@student/EDIT_SHOW_HOW_KNOW',
  EDIT_STUDENT_IDENTIFICATION = '@student/EDIT_STUDENT_IDENTIFICATION',
}

export enum StudentPreferences {
  VIDEO = 0,
  TEXT = 1,
}

export interface StudentAddress {
  addressComplement?: string
  city: string
  district: string
  number: string
  state: string
  street: string
  zipcode: string
}

export interface Student {
  _id: string
  avatar: string
  email: string
  name: string
  telephone: string
  document: string
  ativo: boolean
  address: StudentAddress
  updatedAt: Date
  createdAt: Date
  subscription: any[]
  preference: StudentPreferences | null
  birthdate: Date | string
  old_id: number
  howKnow: string
  showHowKnow: boolean
  tracked?: boolean
}

export interface StudentState {
  readonly profile: Student
}
